import { FunctionComponent, useEffect } from 'react';
import { useMask } from '@react-three/drei';
import { OnlyBotThreeMesh } from '@animavirtuality/onlybots-three';
import { SelectBloom } from '@/components/SelectBloom';

type Props = {
    mesh: OnlyBotThreeMesh;
    useStencil?: boolean;
};
export const BotMeshRenderer: FunctionComponent<Props> = ({ mesh, useStencil = false }) => {
    const stencil = useMask(1);
    useEffect(() => {
        if (useStencil) {
            mesh.material.stencilWrite = stencil.stencilWrite;
            mesh.material.stencilRef = stencil.stencilRef;
            mesh.material.stencilFail = stencil.stencilFail;
            mesh.material.stencilFunc = stencil.stencilFunc;
            mesh.material.stencilZFail = stencil.stencilZFail;
            mesh.material.stencilZPass = stencil.stencilZPass;
        }
    }, [
        mesh,
        stencil.stencilFail,
        stencil.stencilFunc,
        stencil.stencilRef,
        stencil.stencilWrite,
        stencil.stencilZFail,
        stencil.stencilZPass,
        useStencil,
    ]);

    return (
        <SelectBloom enabled={mesh.bloom}>
            <mesh geometry={mesh.geometry} material={mesh.material} castShadow={false} receiveShadow={false} />
        </SelectBloom>
    );
};
